
import { useEffect, useMemo, useRef, useState } from "react";
import { Check, ChevronDown } from "lucide-react";
import useAuthStore from "../../Zustand/Store/useAuthStore";
import TableConfigForm from "./TableConfigForm";
import { MAIN_URL } from "../../Configurations/Urls";

export default function MultiTableConfig() {
  const { userData } = useAuthStore();
  const org = userData?.organization;
    const tables = useMemo(() => [
  
      {
        id: "employees",
        tablename: "Employees",
        tableheading: "employee-list",
        apiFieldsConfig:    `${MAIN_URL}/api/organizations/${org?.organization_id}/employee?mode=2`,
        datagridKeyProp: `Employees_grid_${org?.organization_id}`,
      },

      {
        id: "employee_exit",
        tablename: "Employee Exits",
        tableheading: "employee_exit",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-exit?mode=1`,
        datagridKeyProp: `employee_exits_grid_${org?.organization_id}`,
      },
     
      {
        id: "employment_records",
        tablename: "Employee Records",
        tableheading: "employment_records",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-records?mode=1`,
        datagridKeyProp: `employee_employment_records_grid_${org?.organization_id}`,
      },
      {
        id: "employee_functional_role",
        tablename: "Employee Functional Roles",
        tableheading: "employee_functional_roles",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/emp-func-role?mode=1`,
        datagridKeyProp: `employee_functional_roles_grid_${org?.organization_id}`,
      },
  
      {
        id: "employment_stages",
        tablename: "Employment Stages",
        tableheading: "employment_stages",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employment-stages?mode=1`,
        datagridKeyProp: `organization_employment_stages_grid_${org?.organization_id}`,
      },
  
      {
        id: "employee_document_types",
        tablename: "Document Types",
        tableheading: "employee_document_types",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employemnt-document-type?mode=1`,
        datagridKeyProp: `employee_document_types_grid_${org?.organization_id}`,
      },
  
      {
        id: "documents",
        tablename: "Employee Documents",
        tableheading: "documents",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employemnt-document?mode=1`,
        datagridKeyProp: `employee_documents_grid_${org?.organization_id}`,
      },
  
      {
        id: "work_shifts",
        tablename: "Work Shifts",
        tableheading: "work_shifts",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/workshift?mode=1`,
        datagridKeyProp: `organization_work_shifts_grid_${org?.organization_id}`,
      },
  
      {
        id: "employee_shift_assignments",
        tablename: "Employee WorkShift Assignments",
        tableheading: "employee_shift_assignments",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/workshift-assignment?mode=1`,
        datagridKeyProp: `employee_work_shift_assignments_grid_${org?.organization_id}`,
      },
  
      {
        id: "employee_shift_rotation_pattern",
        tablename: "Employees Shift Rotation Pattern",
        tableheading: "employee_shift_rotation_pattern",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/workshift-rotation-pattern?mode=1`,
        datagridKeyProp: `organization_work_shift_rotation_patterns_grid_${org?.organization_id}`,
      },
  
      {
        id: "employee_shift_rotation_days",
        tablename: "Employees Rotation Days",
        tableheading: "employee_shift_rotation_days",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/workshift-rotation-days?mode=1`,
        datagridKeyProp: `organization_work_shift_rotation_days_grid_${org?.organization_id}`,
      },
  
      {
        id: "employee_shift_rotation_assignments",
        tablename: "Employees Rotation Assignments",
        tableheading: "employee_shift_rotation_assignments",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/workshift-rotation-assignment?mode=1`,
        datagridKeyProp:`employee_work_shift_rotation_assignments_grid_${org?.organization_id}`,
      },
  
      {
        id: "attendande_time_logs",
        tablename: "Attendance Time Logs",
        tableheading: "attendande_time_logs",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/attendance-time-logs?mode=1`,
        datagridKeyProp: `organization_person_attendance_timelogs_grid_${org?.organization_id}`,
      },

      {
        id: "employee_attendance_records",
        tablename: "Attendance Records",
        tableheading: "employee_attendance_records",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/attendance-employee-record?mode=1`,
        datagridKeyProp: `organization_person_attendance_records_grid_${org?.organization_id}`,
      },

    
  
      {
        id: "holiday_calender",
        tablename: "Holiday Calendar",
        tableheading: "holiday_calender",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/holiday-calendar?mode=1`,
        datagridKeyProp: `organization_holiday_calendars_grid_${org?.organization_id}`,
      },
  
      {
        id: "employee_leaves",
        tablename: "Employee Leaves",
        tableheading: "employee-leaves",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-leave?mode=1`,
        datagridKeyProp: `employee_leaves_grid_${org?.organization_id}`,
      },
  
      {
        id: "employee_entitlements",
        tablename: "Employees Leave Entitlement",
        tableheading: "employee_entitlements",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-entitlements?mode=1`,
        datagridKeyProp: `organization_leave_entitlements_grid_${org?.organization_id}`,
      },
  
      {
        id: "leave_summary",
        tablename: "Leave Summary Report",
        tableheading: "leave_summary",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-monthlyleave-summary?mode=1`,
        datagridKeyProp: `organization_person_leave_monthly_summaries_grid_${org?.organization_id}`,
      },

      
      {
        id: "organization_person_leave_monthly_summaries",
        tablename: "Leave Type Summary Report",
        tableheading: "leave_type_summary",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-leave-type-monthly-summary?mode=2`,
        datagridKeyProp: `organization_person_leave_type_monthly_summaries_grid_${org?.organization_id}`,
      },

      {
        id: "employee_leave_category_summary",
        tablename: "Leave Category Monthly Summary Report",
        tableheading: "leave_category_summary",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-leave-category-monthly-summary?mode=2`,
        datagridKeyProp: `organization_person_leave_category_monthly_summaries_grid_${org?.organization_id}`,
      },


      // {
      //   id: "leave_category_summary_report",
      //   tablename: "Employee Leave Category Summary Report",
      //   tableheading: "leave_category_summary_report",
      //   apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-leave-category-monthly-summary?mode=1`,
      //   datagridKeyProp: `employee_leave_category_monthly_summaries_grid_${org?.organization_id}`,
      // },
  



  
      {
        id: "leave_balance_report",
        tablename: "Employee Leave Balance Report",
        tableheading: "leave_balance_report",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/leave-balances/taken?mode=1`,
        datagridKeyProp: `employee_leave_balances_grid_${org?.organization_id}`,
      },
  
  
      {
        id: "increment_types",
        tablename: "Increment Types",
        tableheading: "increment_types",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/increment-type?mode=1`,
        datagridKeyProp: `organization_employee_increment_types_grid_${org?.organization_id}`,
      },
  
      {
        id: "increments",
        tablename: "Employee Increments",
        tableheading: "employee_increments",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/increment?mode=1`,
        datagridKeyProp: `employee_increments_grid_${org?.organization_id}`,
      },

    
      {
        id: "departments",
        tablename: "Departments",
        tableheading: "Departments",
        apiFieldsConfig:`${MAIN_URL}/api/organizations/${org?.organization_id}/department?mode=1`,
        datagridKeyProp: `departments_grid_${org?.organization_id}`,
      },
  
      {
        id: "locations",
        tablename: "Locations",
        tableheading: "locations",
        apiFieldsConfig:`${MAIN_URL}/api/organizations/${org?.organization_id}/location?mode=1`,
        datagridKeyProp: `organization_locations_grid_${org?.organization_id}`,
      },
  
      {
        id: "organization_units",
        tablename: "Organization Units",
        tableheading: "organization_units",
        apiFieldsConfig:`${MAIN_URL}/api/organizations/${org?.organization_id}/units?mode=1`,
        datagridKeyProp: `organization_units_grid_${org?.organization_id}`,
      },
  
      {
        id: "designation",
        tablename: "Designation",
        tableheading: "Designation",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/designation?mode=1`,
        datagridKeyProp: `organization_designations_grid_${org?.organization_id}`,
      },
  
      {
        id: "registration",
        tablename: "Registrations",
        tableheading: "registration",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/business-registration?mode=1`,
        datagridKeyProp: `organization_business_registrations_grid_${org?.organization_id}`,
      },

      {
        id: "attendance_deviation_reason",
        tablename: "Attendance Deviation Reason",
        tableheading: "attendance_deviation",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/attendance-deviation-reason?mode=1`,
        datagridKeyProp: `organization_attendance_deviation_reasons_grid_${org?.organization_id}`,
      },



  
      {
        id: "attendance_status_types",
        tablename: "Attendance Status Type",
        tableheading: "attendance_status_types",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/attendance-status-type?mode=1`,
        datagridKeyProp: `organization_attendance_status_types_grid_${org?.organization_id}`,
      },
  
      {
        id: "attendance_break_types",
        tablename: "Attendance Break Types",
        tableheading: "attendance_break_types",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/attendance-break-type?mode=1`,
        datagridKeyProp: `organization_attendance_break_types_grid_${org?.organization_id}`,
      },
  
      {
        id: "attendance_sources",
        tablename: "Attendance Source",
        tableheading: "attendance_sources",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/attendance-source?mode=1`,
        datagridKeyProp: `organization_attendance_sources_grid_${org?.organization_id}`,
      },
  
      {
        id: "attendance_breaks",
        tablename: "Attendance Break",
        tableheading: "attendance_breaks",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/attendance-breaks?mode=1`,
        datagridKeyProp: `organization_attendance_breaks_grid_${org?.organization_id}`,
      },

      {
        id: "organization_recruitment_source_types",
        tablename: "Recruitment Source Types",
        tableheading: "organization_recruitment_source_types",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/recruitment-source-type?mode=1`,
        datagridKeyProp: `organization_recruitment_source_types_grid_${org?.organization_id}`,
      },

      {
        id: "organization_recruitment_sources",
        tablename: "Recruitment Sources",
        tableheading: "organization_recruitment_sources",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/recruitment-source?mode=1`,
        datagridKeyProp: `organization_recruitment_sources_grid_${org?.organization_id}`,
      },

      {
        id: "organization_recruitment_source_contacts",
        tablename: "Recruitment Source Contacts",
        tableheading: "organization_recruitment_source_contacts",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/recruitment-source-contact?mode=1`,
        datagridKeyProp: `organization_recruitment_source_contacts_grid_${org?.organization_id}`,
      },

      {
        id: "organization_recruitment_openings",
        tablename: "Recruitment Openings",
        tableheading: "organization_recruitment_openings",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/recruitment-opening?mode=1`,
        datagridKeyProp: `organization_recruitment_openings_grid_${org?.organization_id}`,
      },

      {
        id: "organization_recruitment_applications",
        tablename: "Recruitment Applications",
        tableheading: "organization_recruitment_applications",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/recruitment-application?mode=1`,
        datagridKeyProp: `organization_recruitment_applications_grid_${org?.organization_id}`,
      },

      {
        id: "organization_work_shift_breaks",
        tablename: "Work Shift Breaks",
        tableheading: "organization_work_shift_breaks",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/workshift-breaks?mode=1`,
        datagridKeyProp: `organization_work_shift_breaks_grid_${org?.organization_id}`,
      },
  
   
  
      {
        id: "leave_policies",
        tablename: "Organization Leave Policy",
        tableheading: "leave_policies",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/leave-policy?mode=1`,
        datagridKeyProp: `organization_leave_policies_grid_${org?.organization_id}`,
      },
  
      {
        id: "organization_functional_roles",
        tablename: "Organization Functional Roles",
        tableheading: "organization_functional_roles",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/func-role?mode=1`,
        datagridKeyProp: `organization_functional_roles_grid_${org?.organization_id}`,
      },
  
      {
        id: "functional_role_specialization",
        tablename: "Functional Role Specialization",
        tableheading: "functional_role_specialization",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/func-role-spec?mode=1`,
        datagridKeyProp: `organization_functional_role_specializations_grid_${org?.organization_id}`,
      },

      {
        id: "internship_types",
        tablename: "Internship Types",
        tableheading: "internship_types",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/internship-type?mode=1`,
        datagridKeyProp: `organization_internship_types_grid_${org?.organization_id}`,
      },
  
      {
        id: "internship_status",
        tablename: "Internship Status",
        tableheading: "internship_status",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/internship-status?mode=1`,
        datagridKeyProp: `organization_internship_statuses_grid_${org?.organization_id}`,
      },

      {
        id: "internship_stages",
        tablename: "Internship Stages",
        tableheading: "internship_stages",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/internship-stages?mode=1`,
        datagridKeyProp: `organization_internship_stages_grid_${org?.organization_id}`,
      },
  
      {
        id: "interns",
        tablename: "Interns",
        tableheading: "interns",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/interns?mode=1`,
        datagridKeyProp: `Interns_grid_${org?.organization_id}`,
      },
  
      {
        id: "intern_exit",
        tablename: "Intern Exit",
        tableheading: "intern_exit",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-exit?mode=1`,
        datagridKeyProp: `intern_exit_records_grid_${org?.organization_id}`,
      },
  
      {
        id: "intern_functional_roles",
        tablename: "Intern Functional Roles",
        tableheading: "intern_functional_roles",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-func-role?mode=1`,
        datagridKeyProp: `intern_functional_roles_grid_${org?.organization_id}`,
      },
  
      {
        id: "intern_leaves",
        tablename: "Intern Leaves",
        tableheading: "intern_leaves",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-leaves?mode=1`,
        datagridKeyProp: `intern_leaves_grid_${org?.organization_id}`,
      },
  
      {
        id: "intern_document_types",
        tablename: "Intern Document Types",
        tableheading: "intern_document_types",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-document-type?mode=1`,
        datagridKeyProp: `intern_document_types_grid_${org?.organization_id}`,
      },
  
      {
        id: "intern_stipend",
        tablename: "Intern Stipend",
        tableheading: "intern_stipend",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-stipend?mode=1`,
        datagridKeyProp: `intern_stipends_grid_${org?.organization_id}`,
      },
  
      {
        id: "intern_time_logs",
        tablename: "Intern Attendance TimeLogs",
        tableheading: "intern_time_logs",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-time-logs?mode=1`,
        datagridKeyProp: `intern_attendance_timelogs_grid_${org?.organization_id}`,
      },

      {
        id: "intern_attendance_records",
        tablename: "Intern Attendance Records",
        tableheading: "intern_attendance_records",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-attendance-record?mode=1`,
        datagridKeyProp: `intern_attendance_records_grid_${org?.organization_id}`,
      },

      {
        id: "intern_certificate",
        tablename: "Intern Certificates",
        tableheading: "intern_certificate",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-certificate?mode=1`,
        datagridKeyProp: `intern_certificates_grid_${org?.organization_id}`,
      },
      {
        id: "intern_leave_monthly_summaries",
        tablename: "Intern Leave Monthly Summary",
        tableheading: "intern_leave_monthly_summaries",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-leave-summaries?mode=1`,
        datagridKeyProp: `intern_leave_monthly_summaries_grid_${org?.organization_id}`,
      },


      {
        id: "intern_leave_type_monthly_summaries",
        tablename: "Intern Leave Type Monthly Summary",
        tableheading: "intern_leave_type_monthly_summaries",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-leave-type-monthly-summary?mode=1`,
        datagridKeyProp: `intern_leave_type_monthly_summaries_grid_${org?.organization_id}`,
      },

      {
        id: "intern_leave_category_monthly_summaries",
        tablename: "Intern Leave Category Monthly Summary",
        tableheading: "intern_leave_category_monthly_summaries",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-leave-category-monthly-summary?mode=1`,
        datagridKeyProp: `intern_leave_category_monthly_summaries_grid_${org?.organization_id}`,
      },

      {
        id: "intern_leave_balances",
        tablename: "Intern Leave balances",
        tableheading: "intern_leave_balances",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-leave-balances?mode=1`,
        datagridKeyProp: `intern_leave_balances_grid_${org?.organization_id}`,
      },

      {
        id: "user_role",
        tablename: "User Roles",
        tableheading: "user_role",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/userrole?mode=1`,
        datagridKeyProp: `organization_roles_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_cycle",
        tablename: "Payroll Cycle",
        tableheading: "payroll_cycle",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-cycle?mode=1`,
        datagridKeyProp: `organization_payroll_cycles_grid_${org?.organization_id}`,
      },
      
      {
        id: "payroll_component_types",
        tablename: "Payroll Component Types",
        tableheading: "payroll_component_types",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-component-type?mode=1`,
        datagridKeyProp: `organization_payroll_component_types_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_components",
        tablename: "Payroll Components",
        tableheading: "payroll_components",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-component?mode=1`,
        datagridKeyProp: `organization_payroll_components_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_component_slabs",
        tablename: "Payroll Component Slabs",
        tableheading: "payroll_component_slabs",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-component-slab?mode=1`,
        datagridKeyProp: `organization_payroll_component_slabs_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_periods",
        tablename: "Payroll Periods",
        tableheading: "payroll_periods",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-period?mode=1`,
        datagridKeyProp: `organization_payroll_periods_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_runs",
        tablename: "Payroll Runs",
        tableheading: "payroll_runs",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-run?mode=1`,
        datagridKeyProp: `organization_payroll_runs_grid_${org?.organization_id}`,
      },

      {
        id: "employee_salary_structures",
        tablename: "Employee Salary Structures",
        tableheading: "employee_salary_structures",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-salary-structure?mode=1`,
        datagridKeyProp: `organization_payroll_employee_salary_structures_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_advances",
        tablename: "Payroll Advances",
        tableheading: "payroll_advances",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-advance?mode=1`,
        datagridKeyProp: `organization_payroll_advances_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_securities",
        tablename: "Payroll Securities",
        tableheading: "payroll_securities",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-security?mode=1`,
        datagridKeyProp: `organization_payroll_securities_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_security_transactions",
        tablename: "Payroll Security Transactions",
        tableheading: "payroll_security_transactions",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-security-transaction?mode=1`,
        datagridKeyProp: `organization_payroll_security_transactions_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_loans",
        tablename: "Payroll Loans",
        tableheading: "payroll_loans",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-loan?mode=1`,
        datagridKeyProp: `organization_payroll_loans_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_loan_types",
        tablename: "Payroll Loan Types",
        tableheading: "payroll_loan_types",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-loan-type?mode=1`,
        datagridKeyProp: `organization_payroll_loan_types_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_loan_transactions",
        tablename: "Payroll Loan Transactions",
        tableheading: "payroll_loan_transactions",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-loan-transaction?mode=1`,
        datagridKeyProp: `organization_payroll_loan_transactions_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_reimbursements",
        tablename: "Payroll Reimbursements",
        tableheading: "payroll_reimbursements",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-reimbursement?mode=1`,
        datagridKeyProp: `organization_payroll_reimbursements_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_reimbursement_types",
        tablename: "Payroll Reimbursement Types",
        tableheading: "payroll_reimbursement_types",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-reimbursement-type?mode=1`,
        datagridKeyProp: `organization_payroll_reimbursement_types_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_adjustments",
        tablename: "Payroll Adjustments",
        tableheading: "payroll_adjustments",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-adjustment?mode=1`,
        datagridKeyProp: `organization_payroll_adjustments_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_adjustment_types",
        tablename: "Payroll Adjustment Types",
        tableheading: "payroll_adjustment_types",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-adjustment-type?mode=1`,
        datagridKeyProp: `organization_payroll_adjustment_types_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_journal_entries",
        tablename: "Payroll Journal Entries",
        tableheading: "payroll_journal_entries",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-journal-entries?mode=1`,
        datagridKeyProp: `organization_payroll_journal_entries_grid_${org?.organization_id}`,
      },

      {
        id: "organization_payroll_run_employees",
        tablename: "Payroll Run Employees",
        tableheading: "payroll_run_employees",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-employee-runs?mode=1`,
        datagridKeyProp: `organization_payroll_run_employees_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_run_employee_components",
        tablename: "Payroll Run Employee Components",
        tableheading: "payroll_run_employee_components",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-run-employee-component?mode=1`,
        datagridKeyProp: `organization_payroll_run_employee_components_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_salary_structure_components",
        tablename: "Payroll Salary Structure Components",
        tableheading: "payroll_salary_structure_components",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll/salary-component?mode=1`,
        datagridKeyProp: `organization_payroll_employee_salary_structure_components_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_account_mappings",
        tablename: "Payroll Account Mappings",
        tableheading: "payroll_account_mappings",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-account-mapping?mode=1`,
        datagridKeyProp: `organization_payroll_account_mappings_grid_${org?.organization_id}`,
      },

      {
        id: "employee_payslips",
        tablename: "Employee Payslips",
        tableheading: "employee_payslips",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-payslip?mode=1`,
        datagridKeyProp: `Employee Payslips_grid_${org?.organization_id}`,
      },

      {
        id: "employee_payslip_components",
        tablename: "Employee Payslip Components",
        tableheading: "employee_payslip_components",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-payslip-component?mode=1`,
        datagridKeyProp: `Employee Payslip Components_grid_${org?.organization_id}`,
      },

      {
        id: "employee_payslip_payments",
        tablename: "Employee Payslip Payments",
        tableheading: "employee_payslip_payments",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-payslip-payment?mode=1`,
        datagridKeyProp: `Payslips Payments_grid_${org?.organization_id}`,
      },

      {
        id: "users",
        tablename: "Users",
        tableheading: "users",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/user?mode=1`,
        datagridKeyProp: `Users_grid_${org?.organization_id}`,
      },

      // --- Data Grid backlog (Workshift / Skills / Learning / Entities) ---
      {
        id: "workshift_days",
        tablename: "Workshift Days",
        tableheading: "workshift_days",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/workshift-days?mode=1`,
        datagridKeyProp: `organization_work_shift_days_grid_${org?.organization_id}`,
      },
      {
        id: "workmodel_days",
        tablename: "Workmodel Days",
        tableheading: "workmodel_days",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/workmodel-days?mode=1`,
        datagridKeyProp: `organization_work_model_days_grid_${org?.organization_id}`,
      },
      {
        id: "functional_role_skills",
        tablename: "Functional Role Skills",
        tableheading: "functional_role_skills",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/func-role-skill?mode=1`,
        datagridKeyProp: `organization_functional_role_skills_grid_${org?.organization_id}`,
      },
      {
        id: "functional_role_skill_elements",
        tablename: "Functional Role Skill Elements",
        tableheading: "functional_role_skill_elements",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/func-role-skill-element?mode=1`,
        datagridKeyProp: `organization_functional_role_skill_elements_grid_${org?.organization_id}`,
      },
      {
        id: "learning_provider_types",
        tablename: "Learning Provider Types",
        tableheading: "learning_provider_types",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/learning-provider-type?mode=1`,
        datagridKeyProp: `organization_learning_provider_types_grid_${org?.organization_id}`,
      },
      {
        id: "learning_providers",
        tablename: "Learning Providers",
        tableheading: "learning_providers",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/learning-provider?mode=1`,
        datagridKeyProp: `organization_learning_providers_grid_${org?.organization_id}`,
      },
      {
        id: "learning_resources",
        tablename: "Learning Resources",
        tableheading: "learning_resources",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/learning-resources?mode=1`,
        datagridKeyProp: `organization_learning_resources_grid_${org?.organization_id}`,
      },
      {
        id: "learning_functional_roles",
        tablename: "Learning Functional Roles",
        tableheading: "learning_functional_roles",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/learning-func-role?mode=1`,
        datagridKeyProp: `organization_learning_resource_functional_roles_grid_${org?.organization_id}`,
      },
      {
        id: "learning_skill_elements",
        tablename: "Learning Skill Elements",
        tableheading: "learning_skill_elements",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/learning-skill-element?mode=1`,
        datagridKeyProp: `organization_learning_resource_skill_elements_grid_${org?.organization_id}`,
      },
      {
        id: "organization_entities",
        tablename: "Organization Entities",
        tableheading: "organization_entities",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/entity?mode=1`,
        datagridKeyProp: `organization_entities_grid_${org?.organization_id}`,
      },
       
      // Add more tables as needed
    ], [org?.organization_id]);

  



  const sortedTables = useMemo(
    () =>
      [...tables].sort((a, b) =>
        String(a.tablename || "").localeCompare(String(b.tablename || ""))
      ),
    [tables]
  );

  const [activeTableId, setActiveTableId] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (sortedTables.length === 0) return;
    const stillValid = sortedTables.some((t) => t.id === activeTableId);
    if (!activeTableId || !stillValid) {
      setActiveTableId(sortedTables[0].id);
    }
  }, [sortedTables, activeTableId]);

  useEffect(() => {
    if (!dropdownOpen) return undefined;
    const onPointerDown = (event) => {
      if (!dropdownRef.current?.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    const onKeyDown = (event) => {
      if (event.key === "Escape") setDropdownOpen(false);
    };
    document.addEventListener("mousedown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [dropdownOpen]);

  const activeTable = useMemo(
    () => sortedTables.find((t) => t.id === activeTableId),
    [sortedTables, activeTableId]
  );

  const handleSelectTable = (tableId) => {
    setActiveTableId(tableId);
    setDropdownOpen(false);
  };

  return (
    <div className="ems-dashboard ems-fade-up">
      <div className="ems-page-head">
        <div>
          <h1 className="ems-page-title">General Datagrid Configuration</h1>
          <div className="ems-page-sub">
            <span>Default columns for Personalize View and lists</span>
            {org?.organization_name ? (
              <>
                <span className="ems-dot" />
                <span>{org.organization_name}</span>
              </>
            ) : null}
          </div>
        </div>
      </div>
      <div className="ems-section-divider" />

      <p className="ems-pv-intro">
        <b>Choose a list</b> — set default visible, filterable, sortable, and
        pinned columns for the organization.
      </p>

      <div className="ems-card ems-dg-select-card">
        <label className="ems-aa-label" id="ems-dg-table-label">
          Select DataGrid
        </label>
        <div className="ems-dg-dropdown" ref={dropdownRef}>
          <button
            type="button"
            className={`ems-fm-input ems-dg-dropdown-trigger${
              dropdownOpen ? " is-open" : ""
            }`}
            aria-haspopup="listbox"
            aria-expanded={dropdownOpen}
            aria-labelledby="ems-dg-table-label"
            onClick={() => setDropdownOpen((open) => !open)}
          >
            <span className="ems-dg-dropdown-value">
              {activeTable?.tablename || "Select a datagrid"}
            </span>
            <ChevronDown size={16} strokeWidth={2} />
          </button>

          {dropdownOpen ? (
            <div className="ems-dg-dropdown-menu" role="listbox">
              <div className="ems-dg-dropdown-list">
                {sortedTables.map((table) => {
                  const selected = table.id === activeTableId;
                  return (
                    <button
                      key={table.id}
                      type="button"
                      role="option"
                      aria-selected={selected}
                      className={`ems-dg-dropdown-option${
                        selected ? " is-selected" : ""
                      }`}
                      onClick={() => handleSelectTable(table.id)}
                    >
                      <span>{table.tablename}</span>
                      {selected ? <Check size={15} strokeWidth={2.5} /> : null}
                    </button>
                  );
                })}
              </div>
            </div>
          ) : null}
        </div>
      </div>

      {activeTable && !String(activeTable.apiFieldsConfig || "").includes("undefined") ? (
        <TableConfigForm
          key={activeTable.datagridKeyProp || activeTableId}
          tablename={activeTable.tablename}
          tableheading={activeTable.tableheading}
          apiFieldsConfig={activeTable.apiFieldsConfig}
          apiPreviewConfig={
            activeTable.apiPreviewConfig || activeTable.apiFieldsConfig
          }
          datagridKeyProp={activeTable.datagridKeyProp}
        />
      ) : null}
    </div>
  );
}

